import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { CredentialsService } from '../services/credentials.service';
import { ApplicationProfileService } from '../services/application-profile.service';
import { AuthenticationService } from '../services/authentication.service';
import { ApplicationProfile } from '../models';

@Injectable({
  providedIn: 'root',
})
export class AlreadyAuthenticatedGuard {
  private readonly credentialsService = inject(CredentialsService);
  private readonly applicationProfileService = inject(ApplicationProfileService);
  private readonly authenticationService = inject(AuthenticationService);
  private readonly router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | boolean | UrlTree {
    if (!this.credentialsService.isAuthenticated()) {
      return true;
    }

    const profile = this.applicationProfileService.getApplicationProfile();
    if (profile) {
      return this.router.createUrlTree([`${profile.Location.LocationId}/dashboard`]);
    }

    return this.authenticationService.getApplicationProfile().pipe(
      map((fetchedProfile: ApplicationProfile) => {
        this.applicationProfileService.setApplicationProfile(fetchedProfile);
        return this.router.createUrlTree([`${fetchedProfile.Location.LocationId}/dashboard`]);
      }),
      catchError(() => of(true as boolean))
    );
  }
}
